import styled from "styled-components";

export const EpisodeContainer = styled.section`
  margin: var(--spacing-medium);
  width: 100%;
  height: 100%;

  .episode-image {
    width: 100%;
    max-width: 200px;
    border-radius: var(--radius-small);
  }

  @media only screen and (max-width: 767px) {
    .episode-image {
      max-width: 100%;
    }

  }
  .episode-header {
    display: flex;
    justify-content: center;
  }
  @media only screen and (max-width: 767px) {
    .episode-player .episode-header {
      display: none
    }
  }
  .episode-channel_name{
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;

    letter-spacing: 0.05em;

    color: #666666
  }
  .episode-plays-time{
    padding: 10px 0;
    margin-top: 20px;
    margin-bottom: 2.8rem;
    .plays{
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      margin-right: 28px;
    }
    .time{
      display: inline-block
    }
  }
  .episode-plays-time-mobile {
    .plays {
      display: inline-block;
      margin-right: 10px;
      font-weight: 700;
    }
    .time-mobile {
      display: inline-block;
    }
  }

  .episode-description{
    font-size: 20px;
    font-weight: 400;
    color: #989898;
    font-family: 'Lato';
    margin-bottom: 10rem;
    h6{
      font-family: 'Source Sans Pro';
      font-weight: bold;
      font-size: 22px;
      line-height: 28px;
      color: #666666;
      margin-bottom: 2rem;
    }
  }
  @media only screen and (max-width: 767px) {
    .episode-description {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 134.2%;
      /* or 21px */
      margin-bottom: 5rem;
    }
  }
  .episode-description-mobile{
    font-family: 'Duplicate Slab';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 134.2%;
    /* identical to box height, or 30px */
    margin-bottom: 2.2rem
  }
  .comentarios{
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 28px;
    color: #666666;
    .em-resposta{
      font-size: 12px;
      font-weight: normal;
      span{
        font-weight: bold;
      }
      img{
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }
    .textarea{
      padding: var(--size-small);
      background-color: #f7f7f5;
      height: 150px;
      font-size: 12px;
      font-weight: normal;
      color: #666666;
      resize: none;
    }
    button{
      width: auto;
      border: 1px solid #2196F3;
      border-radius: var(--radius-small);
      padding: 5px 16px;
      font-size: 12px;
      line-height: 24px;
      color: #FFF;
      background-color: #2196F3 ;
    }
    .lista-comentarios{
      margin-top: var(--spacing-medium);
    }
    
  }
  .btn-floating.green {
    .icon {
      color: var(--color-seventh-darken);
    }
  }
  .btn-floating.red {
    .icon {
      color: var(--color-second);
    }
  }
`;
export const RecommendedEpisodes = styled.section`
  width: 100%;
  background: #f5f5f5;
  padding: var(--spacing-small);

  .recommended-title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    color: #666666;
  }
  .episode-card {
    margin: var(--spacing-medium) 0;
    box-shadow: none;
  }
`;
